// src/components/Search/SelectedResultDisplay.js

import React from 'react';
import PropTypes from 'prop-types';

export default function SelectedResultDisplay({ result, selectedSeason, selectedEpisode }) {
  if (!result) return null;

  return (
    <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6 mb-6 bg-glassOverlay p-6 rounded-lg shadow-lg backdrop-blur-md">
      {result.photoUrl ? (
        <img
          src={result.photoUrl !== 'No Image' ? result.photoUrl : 'https://via.placeholder.com/112x160?text=No+Image'}
          alt={result.title || result.name}
          className="w-28 h-40 object-cover rounded-lg shadow-md"
          onError={(e) => { e.target.src = 'https://via.placeholder.com/112x160?text=No+Image'; }}
        />
      ) : (
        <div className="w-28 h-40 bg-gray-700 flex items-center justify-center rounded-lg">
          <span className="text-sm text-gray-300">No Image</span>
        </div>
      )}
      
      <div className="flex flex-col text-left space-y-2">
        <h3 className="text-2xl font-semibold text-accent leading-snug">
          {result.title || result.name}
        </h3>
        
        {result.type === 'tv' && selectedSeason && selectedEpisode && (
          <p className="text-lg text-gray-400">
            Season {selectedSeason}, Episode {selectedEpisode}
          </p>
        )}
        
        <p className="text-sm text-gray-300">
          {result.year} • {result.type === 'movie' ? 'Movie' : 'TV Show'}
        </p>
        
        {result.description && (
          <p className="text-gray-400 text-sm leading-relaxed mt-2 line-clamp-3">
            {result.description.length > 200 ? `${result.description.substring(0, 200)}...` : result.description}
          </p>
        )}
      </div>
    </div>
  );
}

SelectedResultDisplay.propTypes = {
  result: PropTypes.object,
  selectedSeason: PropTypes.number,
  selectedEpisode: PropTypes.number,
};
